export default {
  translations: undefined,
  config: null,
  navigation: {},
  settings: '',
  profileData: '',
  otherPlayerProfileData: '',
  otherPlayerId: '',
  newPlayer: false,
  feedData: '',
  internalStateFeedSize: 500,
  topWinsData: '',
  newLevelAnimationState: undefined,
  boostState: '',
  activeLoader: false,
  errorDetails: '',
  visibleModules: undefined,
  progressBarPercentage: undefined,
  starsProgressBarPercentage: undefined,
  newLevelName: '',
  ticketStream: [],
  streamInterval: undefined,
  isOffline: false,
  activeTournaments: [],
  finishedTournaments: '',
  tournamentDetails: '',
  tournamentLeaderboard: '',
  playerLeaderboard: '',
  tournamentLeaderboardSize: 100,
  formattedTournamentStatus: '',
  subscribedToTournaments: false,
  tournamentRankingInterval: 10000,
  theme: 'dark',
  activeQuests: [],
  questsLastWinners: [],
  questRewards: [],
  activePrize: {},
};
